import { gql } from 'graphql-request'

export const COMPLETE_PROFILE_MUTATION = gql`
  mutation CompleteProfile($input: RegisterInput!) {
    register(input: $input) {
      success
    }
  }
`

export const SYNC_SSO_PROFILE_MUTATION = gql`
  mutation SyncSsoProfile($input: SsoSyncInput!) {
    syncSsoProfile(input: $input) {
      status
    }
  }
`

export const INSERT_IDENTITY_MUTATION = gql`
  mutation InsertIdentity($input: identity_insert_input!) {
    insert_identity(
      objects: [$input]
      on_conflict: { constraint: identity_provider_id_key, update_columns: [] }
    ) {
      affected_rows
    }
  }
`
